var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "article securities" }, [
    _c("div", { staticClass: "article-meta" }, [
      _c("div", { staticClass: "article-meta-container" }, [
        _vm.security
          ? _c("div", { staticClass: "security" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("h1", [_vm._v(_vm._s(_vm.security.IssuerDisplay))]),
              _vm._v(" "),
              _vm.security.TradingData &&
              _vm.security.TradingData.LatestQuotePrice
                ? _c("div", { staticClass: "field-list" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-list-field col" }, [
                      _c("label", [_vm._v("Bid:")]),
                      _vm._v(" "),
                      _c("output", [
                        _vm._v(
                          _vm._s(_vm.security.CurrencyIsoCode) +
                            " " +
                            _vm._s(
                              _vm.security.TradingData.LatestQuotePrice.BidPrice
                            )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-list-field col" }, [
                      _c("label", [_vm._v("Ask:")]),
                      _vm._v(" "),
                      _c("output", [
                        _vm._v(
                          _vm._s(_vm.security.CurrencyIsoCode) +
                            " " +
                            _vm._s(
                              _vm.security.TradingData.LatestQuotePrice.AskPrice
                            )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-list-field col" }, [
                      _c("label", [_vm._v("Mid:")]),
                      _vm._v(" "),
                      _c("output", [
                        _vm._v(
                          _vm._s(_vm.security.CurrencyIsoCode) +
                            " " +
                            _vm._s(_vm.Mid)
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.security.TradingData &&
              _vm.security.TradingData.LatestQuotePrice
                ? _c("hr")
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "field-list col" }, [
                _c("div", { staticClass: "field-list-field" }, [
                  _c("label", [_vm._v("Mnemonic:")]),
                  _vm._v(" "),
                  _c("output", [_vm._v(_vm._s(_vm.security.Mnemonic))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field-list-field" }, [
                  _c("label", [_vm._v("Security Type:")]),
                  _vm._v(" "),
                  _c("output", [
                    _vm._v(
                      _vm._s(
                        _vm.security.Type === "Bond"
                          ? "Bond"
                          : _vm.security.SubtypeDisplay
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field-list-field" }, [
                  _c("label", [_vm._v("Currency:")]),
                  _vm._v(" "),
                  _c("output", [_vm._v(_vm._s(_vm.security.CurrencyIsoCode))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field-list-field" }, [
                  _c("label", [_vm._v("Security Class:")]),
                  _vm._v(" "),
                  _c("output", [_vm._v(_vm._s(_vm.security.Name))]),
                ]),
                _vm._v(" "),
                _vm.security.TradingInformation &&
                _vm.security.TradingInformation.MarketMakers &&
                _vm.security.TradingInformation.MarketMakers.length
                  ? _c(
                      "div",
                      { staticClass: "field-list-field" },
                      [
                        _c("label", [_vm._v("Market Maker:")]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.security.TradingInformation.MarketMakers,
                          function (marketMaker) {
                            return _c("output", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: `/members/current-members/${marketMaker.Mnemonic}`,
                                  },
                                },
                                [_vm._v(_vm._s(marketMaker.Name))]
                              ),
                            ])
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-list col" },
                [
                  _vm._l(_vm.security.AllIsins, function (isin) {
                    return _vm.security.AllIsins.length > 0
                      ? [
                          isin.Type == "IsinCode" && isin.Code
                            ? _c("div", { staticClass: "field-list-field" }, [
                                _c("label", [
                                  _vm._v("ISIN"),
                                  isin.Comment
                                    ? _c("span", [
                                        _vm._v(
                                          " (" + _vm._s(isin.Comment) + ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(":"),
                                ]),
                                _vm._v(" "),
                                _c("output", [_vm._v(_vm._s(isin.Code))]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          isin.Type == "CommonCode" && isin.Code
                            ? _c("div", { staticClass: "field-list-field" }, [
                                _c("label", [
                                  _vm._v("Common Code"),
                                  isin.Comment
                                    ? _c("span", [
                                        _vm._v(
                                          "  (" + _vm._s(isin.Comment) + ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(":"),
                                ]),
                                _vm._v(" "),
                                _c("output", [_vm._v(_vm._s(isin.Code))]),
                              ])
                            : _vm._e(),
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-list-field" }, [
                    _c("label", [_vm._v("Date Listed:")]),
                    _vm._v(" "),
                    _c("output", [
                      _vm._v(
                        _vm._s(
                          _vm.format(
                            _vm.parseISO(_vm.security.ListedAt),
                            "dd-MM-yyyy"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-list-field" }, [
                    _c("label", [_vm._v("Domicile:")]),
                    _vm._v(" "),
                    _c("output", [
                      _vm._v(
                        _vm._s(_vm.security.IssuerDetail.Address.Country.Name)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-list-field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.AgentOrSponsorLabel) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("output", [
                      _vm.AgentOrSponsor
                        ? _c("a", { attrs: { href: _vm.AgentOrSponsorUrl } }, [
                            _vm._v(_vm._s(_vm.AgentOrSponsor)),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-list-field" }, [
                    _c("label", [_vm._v("Issuer:")]),
                    _vm._v(" "),
                    _c("output", [
                      _vm.security.Issuer
                        ? _c("a", { attrs: { href: _vm.IssuerUrl } }, [
                            _vm._v(_vm._s(_vm.security.IssuerDetail.Name)),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.security.IssuerDetail.Address
                ? _c("div", { staticClass: "field-list" }, [
                    _c("div", { staticClass: "field-list-field" }, [
                      _c("label", [_vm._v("Company Address:")]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "output",
                        [
                          _vm.security.IssuerDetail.Address.Line1
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.security.IssuerDetail.Address.Line1
                                    ) +
                                    "\n                                "
                                ),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.security.IssuerDetail.Address.Line2
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.security.IssuerDetail.Address.Line2
                                    ) +
                                    "\n                                "
                                ),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.security.IssuerDetail.Address.Line3
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.security.IssuerDetail.Address.Line3
                                    ) +
                                    "\n                                "
                                ),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.security.IssuerDetail.Address.City
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.security.IssuerDetail.Address.City
                                    ) +
                                    "\n                                "
                                ),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.security.IssuerDetail.Address.Postcode
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.security.IssuerDetail.Address.Postcode
                                    ) +
                                    "\n                                "
                                ),
                                _c("br"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.security.IssuerDetail.Address.Country
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.security.IssuerDetail.Address.Country
                                        .Name
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.security.IssuerDetail.Address ? _c("hr") : _vm._e(),
            ])
          : _c("div", { staticClass: "skeleton" }, [
              _c("p", { staticClass: "subheader" }, [
                _vm._v("Listed Securities"),
              ]),
              _vm._v(" "),
              _c("h2"),
              _vm._v(" "),
              _c("h1"),
              _vm._v(" "),
              _c("p"),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("p", { staticClass: "long" }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("p"),
              _vm._v(" "),
              _c("p", { staticClass: "long" }),
              _vm._v(" "),
              _c("hr"),
            ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "article-content" },
      [
        _c("SecurityDetails", {
          attrs: { security: _vm.security, stats: _vm.stats },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "subheader" }, [
      _c("a", { attrs: { href: "/market/securities" } }, [
        _vm._v("Listed Securities"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-list-field" }, [
      _c("label", [_vm._v("Today's Price Data")]),
      _vm._v(" "),
      _c("p", [_vm._v("Price data up to 15 min delayed")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }